import { render, staticRenderFns } from "./CustomerTrainingItemTasks.vue?vue&type=template&id=70f675d2&"
import script from "./CustomerTrainingItemTasks.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingItemTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports